import React, { useEffect } from "react";
import { gql, useQuery } from "@apollo/client";
import { withStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography
} from "@material-ui/core";
import SchoolTournamentList from "./SchoolTournamentList";
import SchoolGameList from "./SchoolGameList";
import { useParams } from "react-router-dom";
import SchoolPlayerList from "./SchoolPlayerList";
import { DEFAULT_TITLE } from "../../constants";

const styles = theme => ({
  root: {
    maxWidth: 1200,
    marginTop: theme.spacing(5),
    padding: theme.spacing(2),
    overflowX: "auto",
    margin: "auto"
  }
});

const GET_SCHOOL = gql`
  query schoolQuery($id: Int) {
    School(id: $id) {
      full_name
      short_name
      type
      points
      wins
      losses
      pp20tuh
      totalTournaments
      totalGames
    }
  }
`;

function School(props) {
  const { classes } = props;
  const { id } = useParams();

  const { loading, data, error } = useQuery(GET_SCHOOL, {
    variables: {
      id: parseInt(id)
    }
  });

  useEffect(() => {
    document.title = `${
      !loading ? data.School[0].short_name : "School"
    } - ${DEFAULT_TITLE}`;
  });

  return (
    <Paper className={classes.root}>
      {loading && !error && <p>Loading...</p>}
      {error && !loading && <p>Error</p>}
      {data && !loading && !error && (
        <div>
          <Typography variant="h4" gutterBottom>
            {`${data.School[0].full_name} (${data.School[0].short_name})`}
          </Typography>
          <Typography variant="h6" gutterBottom>
            {data.School[0].type}
          </Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Points</TableCell>
                <TableCell>Wins</TableCell>
                <TableCell>Losses</TableCell>
                <TableCell>PP20TUH</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Totals</TableCell>
                <TableCell>{data.School[0].points?.toLocaleString()}</TableCell>
                <TableCell>{data.School[0].wins?.toLocaleString()}</TableCell>
                <TableCell>{data.School[0].losses?.toLocaleString()}</TableCell>
                <TableCell>{data.School[0].pp20tuh?.toFixed(2)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      )}
      {data && !loading && !error && (
        <SchoolTournamentList
          schoolId={parseInt(id)}
          totalTournaments={data.School[0].totalTournaments}
        ></SchoolTournamentList>
      )}
      {data && !loading && !error && (
        <SchoolGameList
          schoolId={parseInt(id)}
          totalGames={data.School[0].totalGames}
        ></SchoolGameList>
      )}
      {data && !loading && !error && (
        <SchoolPlayerList
          schoolId={parseInt(id)}
          totalGames={200}
        ></SchoolPlayerList>
      )}
    </Paper>
  );
}

export default withStyles(styles)(School);
